import styled from "styled-components";
import { size } from "styled-theme";
import SectionHeading from "./sectionHeading";

export const FieldWellHeader = styled(SectionHeading)`
  @media only screen and (min-width: ${size("S")}) {
    padding-bottom: 12px;
    padding-top: 30px;
  }
`;